module.exports = __webpack_public_path__ + "img/booking.dd7d3423.svg";